import Loader from 'bharat-ui/web/Loader';
import { makeStyles } from 'bharat-ui/web/Styles';
import React, { useEffect, useState } from 'react';
import { JuspayWebPaymentModesSlice, useJuspayWebPaymentModes, triggerJuspayWebPaymentModesApi } from 'Slices';
import { useDispatch } from 'react-redux';
import { showPostPeUI, showTwelvePcUI, showZillionUi } from 'utils/Utils';
import Toasty from 'components/atoms/Toasty';
import { getURLParameter } from 'utils/nativeSupport';
import { registerSlice } from 'store';
import { useHistory, useParams } from 'react-router-dom';
import LoaderNew from 'components/atoms/Loader';

registerSlice(JuspayWebPaymentModesSlice);

const useStyle = makeStyles(() => ({
	mainContainer: {
		background: '#ffffff',
		height: '100vh',
	},
	height100: {
		height: Number(getWidth()) < 800 ? getHeight() : '100vh',
		width: Number(getWidth()) < 800 ? getWidth() : '65vw',
		overflow: 'hidden',
	},
}));

declare global {
	interface Window {
		HyperServices: any;
	}
}

const getHeight = function () {
	let myHeight = 0;
	if (typeof window.innerHeight == 'number') {
		//Non-IE
		myHeight = window.innerHeight;
	} else if (document.documentElement && document.documentElement.clientHeight) {
		//IE 6+ in 'standards compliant mode'
		myHeight = document.documentElement.clientHeight;
	} else if (document.body && document.body.clientHeight) {
		//IE 4 compatible
		myHeight = document.body.clientHeight;
	}
	return myHeight;
};
const getWidth = function () {
	let myWidth = 0;
	if (typeof window.innerWidth == 'number') {
		//Non-IE
		myWidth = window.innerWidth;
	} else if (document.documentElement && document.documentElement.clientWidth) {
		//IE 6+ in 'standards compliant mode'
		myWidth = document.documentElement.clientWidth;
	} else if (document.body && document.body.clientWidth) {
		//IE 4 compatible
		myWidth = document.body.clientWidth;
	}
	return myWidth;
};

const JuspayWebLandingPage: React.FC = () => {
	const isShowTwelvePcUI = showTwelvePcUI();
	const isShowPostPeUI = showPostPeUI();
	const isShowZillionUi = showZillionUi();
	const classes = useStyle();
	const dispatch = useDispatch();
	const history = useHistory();
	const [loading, setLoading] = useState(true);
	const juspayPaymentModesData = useJuspayWebPaymentModes();
	const checkout = getURLParameter(window.location.href, 'checkout') || '';
	const params: any = useParams();
	let hyperServiceObject: any;

	useEffect(() => {
		if (!juspayPaymentModesData?.data?.transaction) {
			dispatch(triggerJuspayWebPaymentModesApi({ checkout }));
		}
	}, []);

	useEffect(() => {
		if (juspayPaymentModesData?.data?.payloads?.initiate) {
			loadJuspayScript(juspayPaymentModesData?.data?.payloads);
		}
	}, [juspayPaymentModesData?.data?.payloads, dispatch]);

	const loadScript = (src: string, clientId: string, service: string) => {
		console.log('==============payload of SDK==================', src, clientId, service);
		return new Promise((resolve) => {
			const script: any = document.createElement('script');
			script.src = src;
			script.clientId = clientId || '';
			script.service = service || '';
			script.onload = () => {
				resolve(true);
			};
			script.onerror = () => {
				resolve(false);
			};
			document.body.appendChild(script);
		});
	};

	function hyperCallbackHandler(eventData: any) {
		try {
			if (eventData) {
				const eventJSON = typeof eventData === 'string' ? JSON.parse(eventData) : eventData;
				const event = eventJSON.event;
				// Check for event key
				if (event == 'initiate_result') {
					console.log('initiate_result here', event, ' Event data', eventData);
					if (hyperServiceObject.isInitialised()) {
						handleProcessCall();
					} else {
						console.log('not initialised here', event, ' Event data', eventData);
					}
				} else if (event == 'process_result') {
					console.log('process_result here', event, ' Event data', eventData);
				} else if (event == 'user_event') {
					console.log('user_event here', event, ' Event data', eventData);
				} else {
					console.log('Unhandled event', event, ' Event data', eventData);
				}
			} else {
				console.log('No data received in event', eventData);
			}
		} catch (error) {
			console.log('Error in hyperSDK response', error);
		}
	}

	const loadJuspayScript = async (Payloads: any) => {
		const { payload: signaturePayload, requestId, service } = Payloads?.initiate;

		const { action, clientId, merchantId, environment } = signaturePayload;

		const res = await loadScript('https://public.releases.juspay.in/hyper-sdk-web/HyperServices.js', clientId, service);

		if (!res) {
			alert('Juspay SDK failed to load. Are you online?');
			return;
		}
		console.log('==============response of loading SDK==================', res);

		const tempPayload = {
			action: action,
			clientId: clientId,
			merchantId: merchantId,
			environment: environment,
			integrationType: 'iframe',
			hyperSDKDiv: 'PgWebViewDiv', // Div ID to be used for rendering
		};

		const sdkPayload = {
			service: service,
			requestId: requestId,
			payload: tempPayload,
		};

		console.log('==============payload of initiate SDK==================', sdkPayload);
		hyperServiceObject = new window.HyperServices();
		hyperServiceObject.initiate(sdkPayload, hyperCallbackHandler);
	};

	const handleProcessCall = () => {
		const { process: processPayload } = juspayPaymentModesData?.data?.payloads;
		console.log('==============payload of process SDK==================', processPayload);
		setLoading(false);
		hyperServiceObject.process(processPayload);
	};

	return (
		<div
			className={isShowTwelvePcUI || isShowPostPeUI ? classes.mainContainer : 'flex flex-center flex-justify-center'}>
			{isShowTwelvePcUI || isShowZillionUi ? (
				<LoaderNew loading={loading} loaderType={isShowTwelvePcUI ? '12pc' : 'zillion'} />
			) : (
				<Loader loading={loading} />
			)}
			<div className={classes.height100} id="PgWebViewDiv" />
		</div>
	);
};

export default JuspayWebLandingPage;
